module.exports = __webpack_public_path__ + "img/img7.4acc18ba.svg";